import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { visitPaths } from '~libs.desktop.shared.paths';

import { doctorsFilterSessionStorage } from '../AppointmentsFilterPanel/fields/DoctorsFilter/DoctorsFilter.storage';

import { ChipFilter } from './ChipFilter';
import { getDoctorsChipFilterLabel } from './DoctorsChipFilter.utils';

type DoctorsChipFilterProps = {
   readonly practitionerIds: Array<PractitionerId>;
   readonly healthcareProviderDoctors: DoctorSimple[];
};

export const DoctorsChipFilter = (props: DoctorsChipFilterProps): JSX.Element => {
   return (
      <ChipFilter
         label={getDoctorsChipFilterLabel(
            props.practitionerIds.map((id) => id.toString()),
            props.healthcareProviderDoctors
         )}
         searchParamKey={visitPaths.APPOINTMENTS_PRACTITIONER_SEARCH_PARAM}
         testId={'doctorsFilter'}
         onClick={doctorsFilterSessionStorage.removePractitionerIdsFilter}
      />
   );
};
